export const PADDING = {
    lg: 8,
    md: 6,
    sm: 6,
};
export const SIZE = {
    lg: 24,
    md: 18,
    sm: 16,
};
